module.exports = __webpack_public_path__ + "r-v3/img/media.b98b9d38.svg";